var map = {
	"./cognitive_img01.png": "821b",
	"./cognitive_img02.png": "d3a1",
	"./cognitive_img03.png": "5798",
	"./cognitive_img04.png": "57f9",
	"./cognitive_img05.png": "aa70",
	"./cognitive_img06.png": "0c5a",
	"./cognitive_img07.png": "f0b0",
	"./cognitive_img08.png": "68c8",
	"./cognitive_img09.png": "b2e4",
	"./cognitive_img10.png": "5148",
	"./company_happytablebi.png": "d869",
	"./company_introduction.png": "6fc2",
	"./experience_logo.png": "e3c2",
	"./footer_logo.png": "4877",
	"./happytable.png": "1132",
	"./happytable_product1.png": "c29e",
	"./ic_bigimg.png": "924b",
	"./ic_checklist.png": "2cc4",
	"./ic_close.png": "670e",
	"./ic_cognition.png": "4b0c",
	"./ic_company.png": "67f9",
	"./ic_facebook.png": "c903",
	"./ic_game_more.png": "f2f4",
	"./ic_gameresult.png": "c33e",
	"./ic_happytable_cms.png": "87bc",
	"./ic_happytable_consent.png": "c204",
	"./ic_happytable_datastorage.png": "36b2",
	"./ic_happytable_management.png": "4ab7",
	"./ic_happytable_no1.png": "dfd4",
	"./ic_happytable_no2.png": "682c",
	"./ic_happytable_no3.png": "7daf",
	"./ic_happytable_no4.png": "1e9c",
	"./ic_happytable_no5.png": "3dae",
	"./ic_happytable_no6.png": "f581",
	"./ic_happytable_paly.png": "c7b7",
	"./ic_happytable_play.png": "3f51",
	"./ic_happytable_usedata.png": "fbe2",
	"./ic_history.png": "d441",
	"./ic_instagram.png": "b336",
	"./ic_mentalhealth.png": "8489",
	"./ic_news.png": "27a9",
	"./ic_newsmore.png": "28bf",
	"./ic_partner.png": "ccb2",
	"./ic_slide_point1.png": "0e02",
	"./ic_slide_point2.png": "92ac",
	"./ic_top.png": "9322",
	"./img_history.png": "1504",
	"./img_history_line.png": "da28",
	"./logo.png": "1f31",
	"./main_gamebg.png": "6fa5",
	"./main_img_1.png": "805f",
	"./main_img_2.png": "7ad1",
	"./main_img_3.png": "b848",
	"./main_partner_inquiry.png": "567c",
	"./main_partner_inquiry_hover.png": "33a2",
	"./main_partner_reference.png": "7ebc",
	"./main_partner_reference_hover.png": "591d",
	"./main_partnerbg.png": "4af2",
	"./main_top_img.png": "59bc",
	"./map.png": "0f4f",
	"./menu.png": "d62c",
	"./menu_round.png": "4105",
	"./partner_logo01.png": "8a6f",
	"./partner_logo02.png": "123d",
	"./partner_logo03.png": "706d",
	"./partner_logo04.png": "ad80",
	"./partner_logo05.png": "4a4f",
	"./partner_logo06.png": "dafa",
	"./partner_logo07.png": "5cc1",
	"./partner_logo08.png": "9aa5",
	"./partner_logo09.png": "78577",
	"./partner_logo10.png": "d818",
	"./partner_logo11.png": "14ad",
	"./partner_logo12.png": "ec85",
	"./partner_logo13.png": "7d22",
	"./partner_logo14.png": "5454",
	"./partner_logo15.png": "62ff",
	"./partner_logo16.png": "ce89",
	"./partner_logo2.png": "4aef",
	"./partner_logo3.png": "094c",
	"./partner_logo8.png": "25cd",
	"./partner_logo9.png": "6102",
	"./quotes_left.png": "9ac5",
	"./quotes_right.png": "6ca1",
	"./slide_arrow_left.png": "363e",
	"./slide_arrow_right.png": "eb68"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "210b";